/* global ym */
import Block from "base/Block";
import { Fancybox } from "@fancyapps/ui";
class PopupForm extends Block {
	static get blockName() {
		return 'b-popup-form';
	}

	onInit() {
		//TODO: костыль для закрытия fancybox, исправить в дальнейшем
		document.removeEventListener("fancybox.close", this._closeHandler);
		this._closeHandler = () => Fancybox.close();
		document.addEventListener("fancybox.close", this._closeHandler);

		let id = this.el.getAttribute('id');
		let openPopupButton = document.querySelectorAll('.js-open-popup[href="#' + id + '"]');
		openPopupButton.forEach((el) => {
			let src = el.getAttribute('href');

			if (document.querySelector(src)) {
				el.addEventListener('click', function (e) {
					e.preventDefault()
					if (src === '#appointment') ym(105877761, 'reachGoal', 'zapis-cherez-pop-ap');
					Fancybox.show([{ src: src, type: "inline" }]);
				})
			}
		})
	}
}

Block.register(PopupForm);

export default PopupForm;